import * as Yup from "yup";

export const FormSchema = Yup.object().shape({
  project: Yup.array().min(1,"Wybierz projekt").max(1, "Wybierz projekt"),
  kinds: Yup.array().min(1, "Wybierz rodzaj kontroli"),
  type: Yup.object({
    description: Yup.string().required("Wybierz typ kontroli"),
  }),
  mode: Yup.object({
    description: Yup.string().required("Wybierz tryb kontroli"),
  }),
  dateFrom: Yup.date().required("Wybierz datę rozpoczęcia kontroli"),
  dateTo: Yup.date()
    .when(
      'dateFrom',
      (dateFrom, schema) => (
        dateFrom && schema.min(
          dateFrom, 
           "Data zakończenia nie może być wcześniejsza niż data rozpoczęcia"
      )),
    )
    .required("Wybierz datę zakończenia kontroli"),
  controllers: Yup.array().min(1, "Wybierz pracownika"),
  controlList: Yup.array().min(1, "Wybierz listę").max(1, "Wybierz listę")
});
